import { Metric } from '../../Insights/constants';
import { InsightsDetailsQueryParams, QueryParamDataType } from '../constants';
import InsightsPageQueryParams from './InsightsPageQueryParams';

const InsightsDetailsPageQueryParams = {
  ...InsightsPageQueryParams,
  [InsightsDetailsQueryParams.METRIC]: {
    required: true,
    type: QueryParamDataType.STRING,
    acceptedValues: Metric,
  },
};

export default InsightsDetailsPageQueryParams;
